export default __webpack_public_path__ + "static/media/281.aac2af00.jpg";